import { useState } from "react";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Grid, IconButton, InputAdornment, Typography } from "@mui/material";

import pages from "../../../constants/pages";
import { TextField } from "../../../components";
import { colors } from "../../css components/Style";
import Sprintex from "../../../assets/sprintexx.png";
import { PrimaryLoadingButton } from "../../css components/Button";

export default function FormDisplay({ formikProps }) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Grid container spacing={6}>
      <Grid size={12} textAlign={"center"}>
        <img
          style={{ height: "50px", marginLeft: "-8px", marginBottom: "20px" }}
          src={Sprintex}
          alt="logo"
        />
        <Typography className="font">
          Please sign-in to your account and start the adventure
        </Typography>
      </Grid>

      <Grid size={12}>
        <TextField
          label="Email address"
          required
          formikProps={formikProps}
          name="email"
          placeholder="Email address"
          autoComplete="off"
        />
      </Grid>

      <Grid size={12}>
        <TextField
          label="Password"
          required
          autoComplete="off"
          type={showPassword ? "text" : "password"}
          name="password"
          formikProps={formikProps}
          placeholder="Password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {!showPassword && <VisibilityOffIcon />}
                  {showPassword && <VisibilityIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid size={6} />

      <Grid size={6} textAlign={"end"}>
        <Typography variant="button">
          <Typography
            variant="button"
            style={{ cursor: "pointer", color: colors.sprintexBlue }}
            onClick={() => navigate(pages.resetEmailPasswordPage.route)}
          >
            Forgot Password?
          </Typography>
        </Typography>
      </Grid>

      <Grid size={12}>
        <PrimaryLoadingButton
          fullWidth={true}
          type="submit"
          variant="contained"
          onClick={formikProps.handleSubmit}
          disabled={!formikProps.dirty || !formikProps.isValid}
          loading={formikProps.isSubmitting}
        >
          Log In
        </PrimaryLoadingButton>
      </Grid>

      <Grid size={12} alignSelf="center" textAlign={"center"}>
        <Typography className="font" variant="button">
          New on our platform? &nbsp;
          <Typography
            variant="button"
            style={{ cursor: "pointer", color: colors.sprintexBlue }}
            onClick={() => navigate("/sign-up")}
          >
            Create an account
          </Typography>
        </Typography>

        <br />
      </Grid>
    </Grid>
  );
}
